import { getAxios } from "api/axios";
import { errorCatch } from "api/helper";
import { getNotificationId } from "api/helper";
import { getTokenHeaders } from "api/helper";
import { addParam } from "api/helper";
import { Messages } from "config";
import { ENDPOINT_CERTIFICATES, ENDPOINT_CERTIFICATES_RECOVER } from "config/endpoints";
import { displayNotification } from "store/actions/notification";
import { store } from '../../store/store';
import { NOTIFICATION_SUCCESS } from '../../store/actions/types';

export function getCertificatesApi(payload){
  let headersAndParams = getTokenHeaders( payload.pagination ? payload.pagination : payload.disablePagination ? {} : { per_page: 15 } );

    return getAxios(false).get(
        addParam(
            ENDPOINT_CERTIFICATES,
            {
              '{certificate}': '',
            }
        ),
      {
        headers: headersAndParams.headers,
        params: {
          ...headersAndParams.params,
          disablePagination: payload.disablePagination,
        },
      }
    )
    .then( response => {
        return response && response.data ? response.data : null
      } )
      .catch(
        e => {
          errorCatch( e, {
            401: Messages.UNAUTHENTICATED_ERROR,
            403: Messages.UNAUTHORIZED_ERROR,
            404: Messages.NOT_FOUND_ERROR,
          }, getNotificationId(payload) );

          return e.response;
        }
      );
}

/**
 * Send email recover to certificate user
 * @param {object} payload
 * @param {string} payload.certificateId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function sendEmailRecover(payload) {

  return getAxios( false ).post(
    addParam(
      ENDPOINT_CERTIFICATES_RECOVER,
      {
        '{certificate}': payload.certificateId,
      }
    ),
    {},
    getTokenHeaders(),
  )
    .then(
      response => {
        if (response && response.status === 200) {
          store.dispatch( displayNotification( NOTIFICATION_SUCCESS, Messages.SEND_EMAIL_USER_SUCCESS, payload.notificationId || null ) );
          return response;
        }

        return null;
      }
    )
    .catch(
      e => {
        errorCatch( e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload) );

        return e.response;
      }
    );
}
